<template>
  <v-container
    fluid
    grid-list-md
  >
    <providers-table />
  </v-container>
</template>

<script>
import ProvidersTable from "@/components/NewProviders/ProvidersTable.vue";
export default {
  components: {
    ProvidersTable,
  },
  data() {
    return {
    };
  },
};
</script>
